import { render, staticRenderFns } from "./TeamManage.vue?vue&type=template&id=28258f1b&scoped=true&"
import script from "./TeamManage.vue?vue&type=script&lang=js&"
export * from "./TeamManage.vue?vue&type=script&lang=js&"
import style0 from "./TeamManage.vue?vue&type=style&index=0&id=28258f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28258f1b",
  null
  
)

export default component.exports